/** Contient toutes les chaînes de traduction en liées au js */
export const en = {
    // Global
    word: {
        the: "the",
        at: "at",
        error: "Error",
        arrival: "Arrival",
        departure: "Departure",
    },

    // spécifique
    mqtt: {
        event: {
            validation: "has just validated a title, we wish her a safe journey.",
            order: "has just bought a title, thank you for her trust.",
            registration: "has just created her MyBus account, welcome among us.",
            itinerary: "has just calculated a route, we wish her a safe journey.",
            transfer: "has just transferred an m-Ticket to another user, traveling with MyBus has never been so easy.",
            smsticket: "just bought an SMS ticket, we wish him a safe journey.",
            user: "A user ",
        },
        noEvent: "MQTT Error : Event received unrecognized",
    },

    geocoder: {
        poi: {
            ACCESS_GATEWAY: "Access Gateway",
            ADMINISTRATIVE_DIVISION: "Administrative Division",
            ADVENTURE_SPORTS_VENUE: "Adventure Sports",
            AGRICULTURE: "Agriculture",
            AIRPORT: "Airport",
            AMUSEMENT_PARK: "Amusement Park",
            AUTOMOTIVE_DEALER: "Automotive Dealer",
            BANK: "Bank",
            BEACH: "Beach",
            BUILDING_POINT: "Building",
            BUSINESS_PARK: "Business Park",
            CAFE_PUB: "Cafe Pub",
            CAMPING_GROUND: "Camping Ground",
            CAR_WASH: "Car Wash",
            CASH_DISPENSER: "Cash Dispenser",
            CASINO: "Casino",
            CINEMA: "Cinema",
            CITY_CENTER: "City Center",
            CLUB_ASSOCIATION: "Club Association",
            COLLEGE_UNIVERSITY: "College University",
            COMMERCIAL_BUILDING: "Commercial Building",
            COMMUNITY_CENTER: "Community Center",
            COMPANY: "Company",
            COURTHOUSE: "Courthouse",
            CULTURAL_CENTER: "Cultural Center",
            DENTIST: "Dentist",
            DEPARTMENT_STORE: "Department Store",
            DOCTOR: "Doctor",
            ELECTRIC_VEHICLE_STATION: "Electric Vehicle Station",
            EMBASSY: "Embassy",
            EMERGENCY_MEDICAL_SERVICE: "Emergency Medical Service",
            ENTERTAINMENT: "Entertainment",
            EXCHANGE: "Exchange",
            EXHIBITION_CONVENTION_CENTER: "Convention Center",
            FERRY_TERMINAL: "Ferry Terminal",
            FIRE_STATION_BRIGADE: "Fire Station",
            FRONTIER_CROSSING: "Frontier",
            FUEL_FACILITIES: "Fuel Facilities",
            GOLF_COURSE: "Golf Course",
            GOVERNMENT_OFFICE: "Government Office",
            HEALTH_CARE_SERVICE: "Health Care Service",
            HELIPAD_HELICOPTER_LANDING: "Helipad Helicopter Landing",
            HOLIDAY_RENTAL: "Holiday Rental",
            HOSPITAL_POLYCLINIC: "Hospital Polyclinic",
            HOTEL_MOTEL: "Hotel Motel",
            ICE_SKATING_RINK: "Ice Skating Rink",
            IMPORTANT_TOURIST_ATTRACTION: "Tourist Attraction",
            INDUSTRIAL_BUILDING: "Industrial Building",
            LEISURE_CENTER: "Leisure Center",
            LIBRARY: "Library",
            MANUFACTURING_FACILITY: "Manufacturing Facility",
            MARINA: "Marina",
            MARKET: "Market",
            MEDIA_FACILITY: "Media Facility",
            MILITARY_INSTALLATION: "Military Installation",
            MOTORING_ORGANIZATION_OFFICE: "Motoring Organization",
            MOUNTAIN_PASS: "Mountain Pass",
            MUSEUM: "Museum",
            NATIVE_RESERVATION: "Native Reservation",
            NIGHTLIFE: "Bar/Nightclub",
            NON_GOVERNMENTAL_ORGANIZATION: "Non Governmental Organization",
            OPEN_PARKING_AREA: "Open Parking Area",
            OTHER: "Other",
            PARKING_GARAGE: "Parking Garage",
            PARK_RECREATION_AREA: "Park Recreation Area",
            PETROL_STATION: "Petrol Station",
            PHARMACY: "Pharmacy",
            PLACE_OF_WORSHIP: "Place Of Worship",
            POLICE_STATION: "Police Station",
            PORT_WAREHOUSE_FACILITY: "Port",
            POST_OFFICE: "Post Office",
            PRIMARY_RESOURCE_UTILITY: "factory",
            PRISON_CORRECTIONAL_FACILITY: "Prison",
            PUBLIC_AMENITY: "Public Amenity",
            PUBLIC_TRANSPORT_STOP: "Public Transport Stop",
            RAILWAY_STATION: "Railway Station",
            RENT_A_CAR_FACILITY: "Rent A Car",
            RENT_A_CAR_PARKING: "Rent A Car",
            REPAIR_FACILITY: "Repair Facility",
            RESEARCH_FACILITY: "Research Facility",
            RESIDENTIAL_ACCOMMODATION: "Residential Accommodation",
            RESTAURANT: "Restaurant",
            RESTAURANT_AREA: "Restaurant Area",
            REST_AREA: "Rest Area",
            SCENIC_PANORAMIC_VIEW: "Panoramic View",
            SCHOOL: "School",
            SHOP: "Shop",
            SHOPPING_CENTER: "Shopping Center",
            SPORTS_CENTER: "Sports Center",
            STADIUM: "Stadium",
            SWIMMING_POOL: "Swimming Pool",
            TENNIS_COURT: "Tennis Court",
            THEATER: "Theater",
            TOURIST_INFORMATION_OFFICE: "Tourist Information Office",
            TRAFFIC_LIGHT: "Traffic Light",
            TRAFFIC_SERVICE_CENTER: "Traffic Service Center",
            TRAFFIC_SIGN: "Traffic Sign",
            TRAIL_SYSTEM: "Trail System",
            TRANSPORT_AUTHORITY: "Transport Authority",
            TRUCK_STOP: "Truck Stop",
            VETERINARIAN: "Veterinarian",
            WATER_SPORT: "Water Sport",
            WEIGH_STATION: "Weigh Station",
            WELFARE_ORGANIZATION: "Welfare Organization",
            WINERY: "Winery",
            ZOOS_ARBORETA_BOTANICAL_GARDEN: "Zoos/Garden",
        },
    },

    itinerary: {
        mobiscroll: {
            now: "I'm leaving now",
        },
        tabs: {
            all: "All",
            bus: "Bus",
            tram: "Tram",
            metro: "Metro",
            bike: "Bike",
        },
        filter: {
            DEFAULT: "Fastest",
            MIN_WALKING: "Least walking",
            MIN_TRANSFERS: "Least match"
        },
        position: "My position",
        searching: "We are looking for the fastest route to get to your destination.",
        noResult: {
            title: "Oups !",
            content: "No results found for this route",
        },
        results: {
            single: " route found",
            plural: " routes found",
            arrivalAt: "Arrival in ",
            departureAt: "Departure at ",
            travelTime: "Travel time",
            moreDetails: "See more",
        },
        searchError: {
            title: "Route calculation - Entry error",
            sameAddress: "You have entered the same address twice.",
            invalidAddress: "The address entered is invalid.",
        }
    },

    geolocalisation: {
        error: {
            title: "Geolocation",
            activate: "You must enable geolocation for this site to access this feature",
        },
    },

    toaster: {
        itinerary: {
            title: "Error while searching for a route",
            content: "No trip found for your search",
        },
        graphql: {
            title: "Error while retrieving data",
        },
        map: {
            content: "Error while building the map",
        },
    },

    form: {
        newsletter: {
            title: "Newsletter",
            valid: "Thank you for subscribing to our news!",
        },
        contact: {
            title: "Contact form",
            valid: "Your request has been sent.",
        },
        default: {
            titre: "Form",
            valid: "Your request has been registered !",
            invalid: "Several fields have problems: <br>",
            reason_politique: "- You must accept our privacy policy <br>",
            reason_field: "- The field ",
            reason_invalid: " is invalid<br>",
            reason_empty: " is necessary<br>",
        }
    },

    map: {
        home: "mapbox://styles/fpacotte/ckm4y9z2f0wha17r1sswedrj2",
        itinerary: "mapbox://styles/fpacotte/ckm4y6smjdk1317lj42j2fonc",
    },
};